import { axiosInstance } from "../axiosConfig.ts";
import { IProfile } from "./types.ts";

const basePath = "/v1/profile";

export const profileAPI = {
  getProfile: async (): Promise<IProfile> => {
    const response = await axiosInstance.get<IProfile>(basePath);
    return response.data;
  },
};
